var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_vm._t("actions",null,{"item":item})]}},{key:"item.dateTaken",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("dateFormat")(item.dateTaken)))]}},{key:"item.examType",fn:function(ref){
var item = ref.item;
return [_vm._t("examType",null,{"item":item})]}},{key:"item.skin",fn:function(ref){
var item = ref.item;
return [_vm._t("skin",null,{"item":item})]}},{key:"item.head",fn:function(ref){
var item = ref.item;
return [_vm._t("head",null,{"item":item})]}},{key:"item.eyes",fn:function(ref){
var item = ref.item;
return [_vm._t("eyes",null,{"item":item})]}},{key:"item.mouth",fn:function(ref){
var item = ref.item;
return [_vm._t("mouth",null,{"item":item})]}},{key:"item.resp",fn:function(ref){
var item = ref.item;
return [_vm._t("resp",null,{"item":item})]}},{key:"item.heart",fn:function(ref){
var item = ref.item;
return [_vm._t("heart",null,{"item":item})]}},{key:"item.gastro",fn:function(ref){
var item = ref.item;
return [_vm._t("gastro",null,{"item":item})]}},{key:"item.urinary",fn:function(ref){
var item = ref.item;
return [_vm._t("urinary",null,{"item":item})]}},{key:"item.reprod",fn:function(ref){
var item = ref.item;
return [_vm._t("reprod",null,{"item":item})]}},{key:"item.skeletal",fn:function(ref){
var item = ref.item;
return [_vm._t("skeletal",null,{"item":item})]}},{key:"item.circul",fn:function(ref){
var item = ref.item;
return [_vm._t("circul",null,{"item":item})]}},{key:"item.infectD",fn:function(ref){
var item = ref.item;
return [_vm._t("infectD",null,{"item":item})]}},{key:"item.dieasNV",fn:function(ref){
var item = ref.item;
return [_vm._t("dieasNV",null,{"item":item})]}},{key:"item.dieasTHHot",fn:function(ref){
var item = ref.item;
return [_vm._t("dieasTHHot",null,{"item":item})]}},{key:"item.dieasTHCold",fn:function(ref){
var item = ref.item;
return [_vm._t("dieasTHCold",null,{"item":item})]}},{key:"item.dieasPA",fn:function(ref){
var item = ref.item;
return [_vm._t("dieasPA",null,{"item":item})]}},{key:"item.dieasRad",fn:function(ref){
var item = ref.item;
return [_vm._t("dieasRad",null,{"item":item})]}},{key:"item.injury",fn:function(ref){
var item = ref.item;
return [_vm._t("injury",null,{"item":item})]}},{key:"item.immune",fn:function(ref){
var item = ref.item;
return [_vm._t("immune",null,{"item":item})]}},{key:"item.attachment",fn:function(ref){
var item = ref.item;
return [_vm._t("attachment",null,{"item":item})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }